var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowTopRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 8"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.667 2.333 2 6M3.667 2.044s1.878-.158 2.163.127c.285.284.126 2.162.126 2.162"
}))));
export { SvgArrowTopRight as ReactComponent };
export default __webpack_public_path__ + "df4838d2486027178dc564a88a95f24e.svg";